import React from 'react';
import { useSyncStatus } from '../../contexts/SyncStatusContext';
import { formatDateTime, getLatestSyncTime } from '../../utils/formatDateTime';

/**
 * ページヘッダー用の最終同期時刻表示。
 * @param {{ groups: string[] }} props
 */
export const PageSyncMeta = ({ groups }) => {
  const { status } = useSyncStatus();
  const latest = getLatestSyncTime(status, groups);

  return (
    <span className="meta-text">
      最終同期: {formatDateTime(latest)}
    </span>
  );
};
